import { Box, Button, Card, Grid, Modal, Stack, Typography } from "@mui/material";
import { MdOutlineEdit, MdOutlineWatchLater } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
// import IMAGE from "../../assets/images/big/abcz.png";
import { useEffect, useState } from "react";
import { customStep, update } from "../../slice/jobSlice";
import { useTMutation } from "../../utils/useTMutation";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReplyIcon from '@mui/icons-material/Reply';
import { useTQuery } from "../../utils/useTQuery";
import IMAGE from "../../assets/images/big/abcz.png";
import { API_URL } from "../../appConstants";
import { clearJob, setViewJob } from "../../slice/userSlice";
import showToast from "../Hot-Toast/showToast";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    boxShadow: 24,
    p: 4,
    display: "grid",
    justifyContent: "center",
};

const ViewJob = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { ID } = useParams()
    const [jobData, setJobData] = useState([])
    const [openModal, setOpenModal] = useState(false);
    const { userDetails } = useSelector((state) => state?.user);
    const { data, isLoading, isError, error, refetch } = useTQuery(
        ["viewJob"], `/job/viewJob?${new URLSearchParams({ ID: ID, USER_ID: userDetails?.ID }).toString()}`,
        'get',
        {}
    );
    useEffect(() => {
        if (data?.OUTPUT) {
            setJobData(data?.OUTPUT)
        }

    }, [data])
    useEffect(() => {
        dispatch(clearJob())
    }, [])
    // console.log("fetJob" , data)
    const { mutateAsync } = useTMutation(
        "/job/saveAndRemoveJob",
        "post",
        (response) => {
            if (response.STATUS) {
                return response;
            }
        }
    );
    const acceptOffer = async () => {
        setOpenModal(false);
        let response = await mutateAsync({
            JOB_ID: jobData?.ID,
            USER_ID: userDetails?.ID,
            STATUS: "New",
        });
        if (response.STATUS) {
            setOpenModal(true)
            // showToast("success", "Applied For The Job", 3000);
        } else {
            showToast("error", response?.MESSAGE, 3000);
        }
    }
    const handleValidate = () => {
        if (userDetails?.USER_TYPE === "clinician") {
            acceptOffer()
        } else {
            dispatch(setViewJob(jobData?.ID))
            navigate("/login")

        }

    }
    return (
        <>
            <Grid container justifyContent="center" p={5} style={{ background: "#f5f5f5" }}>
                <Grid lg={8} >
                    <Card>
                        <Grid
                            container
                            alignItems="center"
                            spacing={1}
                            justifyContent="space-around"
                            px={3}
                            pt={2}>
                            <Grid item xs={12} sm={12} display="flex" gap={3}>
                                <Typography pt={2}>
                                    <img src={jobData?.user?.PROFILE_IMAGE_PATH ? API_URL + "user/viewFile?fileName=" + jobData?.user?.PROFILE_IMAGE_PATH : IMAGE} alt="image" />
                                </Typography>
                                <Typography>
                                    <Box pt={2}>
                                        <Typography style={{ fontWeight: 500, fontSize: "14px", color: "#000000", opacity: "87%" }}>{jobData?.user?.FACILITY_NAME}</Typography>
                                        <Typography style={{ fontWeight: 400, fontSize: "12px", color: "#000000", opacity: "60%" }}>{jobData?.user?.STREET_ADDRESS}</Typography>
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography
                                    sx={{
                                        fontSize: "18px",
                                        color: "rgba(0,0,0,0.87)",
                                        fontWeight: 700,
                                    }}>
                                    {jobData?.ROLE_NAME}
                                </Typography>


                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "left",
                                        alignItems: "center",
                                        margin: "auto",
                                        fontWeight: 400,
                                        marginBottom: "10px",
                                    }}>

                                </Box>
                            </Grid>

                        </Grid>

                        <Grid
                            container
                            alignItems="center"
                            spacing={1}
                            px={3}
                            pt={2}> <Grid item> <Button className="custombutton"
                                variant="outlined"
                                color="success"
                                sx={{ my: 1, }}
                                disabled={jobData?.save_jobs?.some(val => val.USER_ID === userDetails.ID)}
                                onClick={handleValidate}
                            >
                                {jobData?.save_jobs?.some(val => val.USER_ID === userDetails.ID) ? jobData?.save_jobs[0]?.STATUS === "New" ? "Applied" : jobData?.save_jobs[0]?.STATUS : "I'm Interested"}
                            </Button></Grid>


                        </Grid>



                        <hr
                            style={{
                                marginTop: "20px",
                                color: "#000000",
                                opacity: "60%",
                                width: "90%",
                                margin: "0 auto",
                            }}
                        />




                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Title:{" "}
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                {jobData?.jobs_role?.ROLE_NAME}
                            </Typography>
                        </Box>

                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Specialty:
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                {jobData?.specialty?.SPECIALTY_NAME}
                            </Typography>
                        </Box>
                        {jobData?.STAFFING_SOLUTION && (
                            <Box display="flex" px={2} pt={1.2}>
                                <Typography
                                    variant="h4"
                                    style={{
                                        fontWeight: 500,
                                        fontSize: "16px",
                                        color: "#000000",
                                        opacity: "87%",
                                    }}>
                                    {/* Staffing Solution: */}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    style={{
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        color: "#000000",
                                        opacity: "60%",
                                        paddingLeft: "3px",
                                    }}>
                                    {jobData?.STAFFING_SOLUTION}
                                </Typography>

                                <Typography></Typography>
                            </Box>
                        )}

                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                {/* Job Type: */}
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                {jobData?.JOB_TYPE}
                            </Typography>
                        </Box>

                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Shift Type:
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                {jobData?.SERVICE_TYPE}
                            </Typography>
                        </Box>

                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Start Date:
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                {new Date(jobData?.SERVICE_DATE).toDateString()}
                            </Typography>
                        </Box>

                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Working Days:
                            </Typography>
                            {/* <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%", paddingLeft:"3px" }}>{props.data.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY
                  }-{props.data.JOB_SERVICE_WITH_DAY_TIME[props.data.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY
                    }</Typography> */}
                        </Box>
                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Time:
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                07:00 - 15:30
                            </Typography>
                        </Box>
                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Pay:
                            </Typography>
                            <Typography
                                variant="h6"
                                style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#000000",
                                    opacity: "60%",
                                    paddingLeft: "3px",
                                }}>
                                ${jobData?.PAY_AMOUNT_FROM}-{jobData?.PAY_AMOUNT_TO}/hr
                            </Typography>
                        </Box>
                        <Box display="flex" px={2} pt={1.2}>
                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 500,
                                    fontSize: "16px",
                                    color: "#000000",
                                    opacity: "87%",
                                }}>
                                Location:
                            </Typography>
                            {/* <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%", paddingLeft:"3px" }} >{userDetails?.STREET_ADDRESS}</Typography> */}
                        </Box>
                    </Card>

                    <Grid mt={2} >

                        <Card>
                            <Grid
                                container
                                alignItems="center"
                                spacing={1}
                                justifyContent="space-around"
                                p={3}
                                pb={3}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    display="flex"
                                    justifyContent="space-between">
                                    {/* <Typography variant="h3" className="about-text">
                                    Job Description
                                </Typography> */}
                                    <Typography
                                        variant="h3"
                                        style={{
                                            fontWeight: 600,
                                            fontSize: "20px",
                                            color: "#000000",
                                            opacity: "87%",
                                        }}>
                                        Job Description
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Typography
                                        id="delete-modal-title"
                                        variant="h6"
                                        component="h2"
                                        style={{
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            color: "#000000",
                                            opacity: "60%",
                                        }}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: jobData?.JOB_DESCRIPION,
                                            }}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} mt={3}>
                                    <Box display="flex" justifyContent="space-between">
                                        <Typography
                                            variant="h3"
                                            style={{
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                color: "#000000",
                                                opacity: "87%",
                                            }}>
                                            Responsibilities:
                                        </Typography>
                                    </Box>

                                    <Typography px={2.5} pt={1}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: jobData?.JOB_RESPONSIBILITY,
                                            }}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                </Grid>
                            </Grid>
                        </Card>

                    </Grid>

                </Grid>


                {openModal && (
                    <Modal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                        aria-labelledby="delete-modal-title"
                        aria-describedby="delete-modal-description">
                        <Card sx={style}>
                            <Box>
                                <Typography
                                    id="delete-modal-title"
                                    variant="h6"
                                    component="h2"
                                    margin={2}
                                    sx={{ textAlign: "center" }}>
                                    {/* <BlockIcon color="error" fontSize='large' /> */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        width="100"
                                        height="100"
                                        viewBox="0 0 48 48">
                                        <linearGradient
                                            id="5zzMGVQnN_QyRYWGmJUsQa_A8xKzsTKHhzn_gr1"
                                            x1="9.858"
                                            x2="38.142"
                                            y1="9.858"
                                            y2="38.142"
                                            gradientUnits="userSpaceOnUse">
                                            <stop offset="0" stop-color="#21ad64"></stop>
                                            <stop offset="1" stop-color="#088242"></stop>
                                        </linearGradient>
                                        <path
                                            fill="url(#5zzMGVQnN_QyRYWGmJUsQa_A8xKzsTKHhzn_gr1)"
                                            d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
                                        <path
                                            d="M32.172,16.172L22,26.344l-5.172-5.172c-0.781-0.781-2.047-0.781-2.828,0l-1.414,1.414	c-0.781,0.781-0.781,2.047,0,2.828l8,8c0.781,0.781,2.047,0.781,2.828,0l13-13c0.781-0.781,0.781-2.047,0-2.828L35,16.172	C34.219,15.391,32.953,15.391,32.172,16.172z"
                                            opacity=".05"></path>
                                        <path
                                            d="M20.939,33.061l-8-8c-0.586-0.586-0.586-1.536,0-2.121l1.414-1.414c0.586-0.586,1.536-0.586,2.121,0	L22,27.051l10.525-10.525c0.586-0.586,1.536-0.586,2.121,0l1.414,1.414c0.586,0.586,0.586,1.536,0,2.121l-13,13	C22.475,33.646,21.525,33.646,20.939,33.061z"
                                            opacity=".07"></path>
                                        <path
                                            fill="#fff"
                                            d="M21.293,32.707l-8-8c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0	L22,27.758l10.879-10.879c0.391-0.391,1.024-0.391,1.414,0l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414l-13,13	C22.317,33.098,21.683,33.098,21.293,32.707z"></path>
                                    </svg>
                                </Typography>
                                <Typography
                                    id="delete-modal-title"
                                    sx={{ textAlign: "center" }}
                                    variant="h4"
                                    component="h2">
                                    Application Submitted
                                </Typography>
                                <Grid container mt={3} justifyContent={"center"} gap={2}>
                                    <Button className="custombutton"
                                        variant="contained"
                                        color="success"
                                        sx={{ width: "90px" }}
                                        onClick={() => {
                                            navigate("/clinician/jobs", { replace: true })
                                        }}>
                                        Continue
                                    </Button>
                                </Grid>
                            </Box>
                        </Card>
                    </Modal>
                )}
            </Grid>



        </>


    )
};

export default ViewJob;

